import React from "react";
import "../components/Styles/Loading.css";
const Loading = () => {

    return(
        <div class="cssloader">
        <div class="sh1"></div>
        <div class="sh2"></div>
        <h4 class="lt">Loading</h4>
    </div>
    )
}
    
export default Loading;